import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-add-question-induc',
  templateUrl: './add-question-induc.component.html',
  styleUrls: ['./add-question-induc.component.css']
})
export class AddQuestionInducComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<AddQuestionInducComponent>,
  ) { }

  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
}
